// fields which will use a date input and must be converted
// to a date filter on the target list page interface
export const UNEDITABLE_COLS = {
    releaseDateDiff: true,
    promoteInSearch: true,
    advertSource: true,
}
